/*

Visibility mixin

Usage:

  You can check if your component is visible in the viewport: this.isVisible

Optional callbacks:

  called when component becomes visible:
    onVisible

  called when component becomes not visible:
    onNotVisible

Options:

  Add visibilityConfig object to props

    - toggle:
      Default is false
      When true, detect when an element becomes visible / non-visible
      When false, only detect the first time an element becomes visible

    - options:
      List of options to pass to IntersectionObserver
      See: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

*/
import 'intersection-observer'

export default {
  data: function () {
    return {
      _observer: null,
      isVisible: false
    }
  },
  mounted: function () {
    const toggle = this.visibilityConfig ? this.visibilityConfig.toggle || false : false
    const options = this.visibilityConfig ? this.visibilityConfig.options || {} : {}

    this._observer = new IntersectionObserver((elements) => {
      if (elements[0].isIntersecting) {
        this.isVisible = true

        if (!toggle) {
          this._observer.disconnect()
          this._observer = null
        }

        if (this.onVisible) {
          return this.onVisible()
        }
      } else if (toggle) {
        this.isVisible = false

        if (this.onNotVisible) {
          return this.onNotVisible()
        }
      }
    }, options)
    this._observer.observe(this.$el)
  },
  destroyed: function () {
    if (this._observer) {
      this._observer.disconnect()
    }
  }
}
